//Input component that allows users to enter multiple values and displays them as chips in an uncontrolled manner using the controlled ChipInput component

import {useState} from "react";
import ChipInput, {ChipInputProps} from "../../input/ChipInput";

export interface FilterChipInputProps
    extends Omit<ChipInputProps, "values" | "onChange" | "inputValue" | "onInputValueChange"> {
    initialValues?: string[];
    onChange: (values: string[]) => void;
}
interface ChipInputState {
    chips: Set<string>;
    current: string;
}

export function FilterChipInput({initialValues, onChange, ...rest}: FilterChipInputProps) {
    const initialChips = initialValues || [];
    const [state, setState] = useState<ChipInputState>({chips: new Set(initialChips), current: ""});

    const onChipInputChange = (chips: string[], current: string) => {
        setState({chips: new Set<string>(chips), current});
        onChange([...chips, current]);
    };

    return (
        <ChipInput {...rest} values={Array.from(state.chips)} onChange={onChipInputChange} inputValue={state.current} />
    );
}
